import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { ScheduleModule } from '@nestjs/schedule';
import { TypeOrmModule } from '@nestjs/typeorm';
import { IndentformController } from './indent-form-controller';
import { IndentMaterialEntity } from './indent-form-entity';
import { IndentFormAdapterFormMaterial } from './indent-form-for-material-adapter';
import { indentFormServices } from './indent-form-service';
import { IndentItemEntity } from './indent-item-entity';

@Module({
    imports: [
      TypeOrmModule.forFeature([IndentMaterialEntity,IndentItemEntity]),
      ScheduleModule.forRoot(),
  
    ],
    controllers: [IndentformController],
    providers: [indentFormServices,IndentFormAdapterFormMaterial,ApplicationExceptionHandler,LogsService],
    exports: [indentFormServices]
  })
  export class IndentFormModule {}